export default "__VITE_ASSET__Bjcqi7bF__"